// extracted by mini-css-extract-plugin
export default {"wrapper":"MapPage_wrapper__8YHkF","back":"MapPage_back__0T82p","text":"MapPage_text__TqaX7"};